// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkEvaluationCard-cls1_hpY","cls2":"WorkEvaluationCard-cls2_FtB WorkEvaluationCard-cls1_hpY"};